/**
 * TanStack Query hooks for `real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys,
	type CreateRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSBody,
	type ListRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSResponse,
	type RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRow,
} from "./api";

export function useRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSList(): UseQueryResult<ListRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSResponse, Error> {
	return useQuery({
		queryKey: realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSCreate(): UseMutationResult<RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRow, Error, CreateRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys.all });
		},
	});
}

export function useRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys.all });
		},
	});
}
